<div class="assessment-overlay">
<div class="assessment-popup">

	<div class="popup-icon">
		<i class="bi bi-exclamation-circle"></i>
	</div>

	<h2 class="popup-title">
		Assessment Already Completed
	</h2>

	<p class="popup-description">
		You have already completed this assessment using this email.
		Re-attempt is not allowed.
	</p>

	<button class="popup-btn" (click)="closePopup()">
		Okay
	</button>

</div>
</div>